export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["min"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koupit"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["za"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivní"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odkaz na inzerát"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maker ID"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Popis"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Timeout"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datum vytvoření"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zaplatím"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obdržím"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Limit obchodu"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vše"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obchody"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID nabídky"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurz"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vybrat účet"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mimo limit"])}
}